

import React, { useState, useEffect,useMemo } from "react";
import axios from "axios";
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Stack,DialogActions,
  Pagination,
  Button,
} from "@mui/material";


import loadergif from "../../../assets/images/BG-switch loader_2.gif";

import Typography from "@mui/material/Typography";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import {  VAVE,GET2B2DATA,DOWNLOADUPLOADEDUSERFILE,DOWNLOADIL5FILE } from "../../../Pages/AppConstant";
import * as XLSX from "xlsx";



// Color mapping
const getStatusColor = (status) => {
  switch ((status || "").toLowerCase()) {
    case "accepted":
      return "green";
    case "rejected":
      return "red";
    case "pending":
    case "inprogress":
      return "orange";
    default:
      return "gray";
  }
};



const isFilled = (v) => {
  if (v == null) return false;                // catches null and undefined
  if (typeof v === "string") return v.trim() !== "";
  return true;                                // for non-strings, treat as present
};

const getQualityOverallStatus = (r) => {
  const url = r?.upload_2d2_sheet_url;
  return isFilled(url) ? "accepted" : "pending";
};




const StatusDot = ({ status, name, onClick }) => (
  <Tooltip title={`Status: ${status} (${name})`} arrow>
    <span
      onClick={onClick}
      style={{
        display: "inline-block",
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        backgroundColor: getStatusColor(status),
        margin: "auto",
        cursor: "pointer",
      }}
    />
  </Tooltip>
);

const IdeaTable = () => {
  const [allIdeas, setAllIdeas] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedApprover, setSelectedApprover] = useState(null);

  const [viewMoreOpenDialog, setViewMoreOpenDialog] = useState(false);
  const [selectedIdea, setSelectedIdea] = useState(null);

  const [isloading, setIsloading] = useState(false);

  const itemsPerPage = 10;

  const fetchIdeas = async () => {
    try {
      const response = await axios.get(VAVE + GET2B2DATA, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const ideas = response?.data?.data || [];
      setAllIdeas(ideas);
    } catch (error) {
      console.error("Error fetching ideas:", error);
    }
  };

  useEffect(() => {
    fetchIdeas();
  }, []);


  const downloadUploadedUserDocApi = (request) => {
    setIsloading(true);
    axios({
      method: "post",
      url: VAVE + DOWNLOADUPLOADEDUSERFILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request?.id_x },
      responseType: "blob",
    })
      .then((response) => {
        if (response?.data?.size === 14) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }

        const contentType = response.headers["content-type"] || "application/pdf";
        const disposition = response.headers["content-disposition"];
        let filename = `Idea_${request?.idea_unique_id || request?.id_x}_User_Document.pdf`;

        // If server sent filename in headers
        if (disposition && disposition.includes("filename=")) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match?.[1]) filename = decodeURIComponent(match[1]);
        }

        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
        setIsloading(false);
      })
      .catch(() => {
        // Fallback: open stored file path if available
        const fallback = request?.filepath || selectedIdea?.filepath;
        if (fallback) window.open(fallback, "_blank");
        setIsloading(false);
      });
  };

  // ---------------------------
  // Enrich rows with computed PD/Quality approvers
  // ---------------------------
  const updatedRequests = useMemo(() => {
    return (allIdeas || []).map((req) => {
      const approvers = [
        {
          role: "APPROVED",
          name: "Karthik Babu Javvaji",
          status: getQualityOverallStatus(req),
        },
      ];
      return { ...req, approvers };
    });
  }, [allIdeas]);


  const filteredIdeas = Array.isArray(updatedRequests)
  ? updatedRequests.filter((item) => {
      const query = searchQuery.toLowerCase();
      return Object.values(item).some((value) =>
        String(value).toLowerCase().includes(query)
      );
    })
  : [];


  const totalPages = Math.ceil((filteredIdeas?.length || 0) / itemsPerPage);
  const paginatedIdeas = filteredIdeas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


  const counts = useMemo(() => {
    const list = updatedRequests;
    const norm = (s) => (s || "").toString().trim().toLowerCase();
    const approvedApproved =
      list.filter((i) => norm(getQualityOverallStatus(i)) === "accepted").length;
    const approvedPending =
      list.filter((i) => norm(getQualityOverallStatus(i)) === "pending").length;


    return {

      approvedApproved,
      approvedPending,

    };
  }, [updatedRequests]);

  // ---------------------------
  // UI Handlers
  // ---------------------------
  const handleDotClick = (req, approver) => {
    setSelectedRequest(req);
    setSelectedApprover(approver);
    setOpenDialog(true);
  };

  const handleViewMore = (idea) => {
    setSelectedIdea(idea);
    setViewMoreOpenDialog(true);
  };

  const handleViewMoreCloseDialog = () => {
    setViewMoreOpenDialog(false);
    setSelectedIdea(null);
  };


  const ideaExcelDownloadSubmit = async () => {
    try {
      const dataToExport = filteredIdeas.length ? filteredIdeas : updatedRequests;

      const filteredData = dataToExport.map((item) => ({
        id: `SWON-${item?.id_x}`,
        idea_category: item?.idea_category || item?.idea_category_x || "",
        partno: item?.partno || "",
        part_description: item?.part_description || "",
        benefit:item.benefit,
        idea_effective:item.idea_effective,
        model:item.model,
        varient:item.varient,
        subvarient:item.subvarient,
        checked_by: "Karthik Babu Javvaji",
        checked_status: getQualityOverallStatus(item),

   
        
      }));

      // Summary sheet (computed counts)
      const summaryAOA = [
        ["Status Summary"],
        ["", "Checked",],
        ["Approved", counts.approvedApproved, ],
        ["Pending", counts.approvedPending, ],
      ];

      const workbook = XLSX.utils.book_new();
      const summarySheet = XLSX.utils.aoa_to_sheet(summaryAOA);
      XLSX.utils.book_append_sheet(workbook, summarySheet, "IL5-Summary");

      const ideasSheet = XLSX.utils.json_to_sheet(filteredData);
      XLSX.utils.book_append_sheet(workbook, ideasSheet, "Ideas");

      XLSX.writeFile(workbook, "2B2-Sign.xlsx");
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };

  return (
    <div className="container mt-2">
      {/* Loader overlay */}
      {isloading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loadergif">
            <img src={loadergif} alt="Loading..." />
          </div>
        </div>
      ) : null}

      {/* Top Bar */}
      <div className="row align-items-center pb-3 pt-2 g-3">
        <div className="col-12 col-md-7 col-lg-7">
          <div className="d-flex align-items-center gap-3 flex-wrap justify-content-md-start">
            <div className="d-flex align-items-center">
              <label className="me-2">Search</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
                style={{ width: "200px" }}
              />
            </div>

            <button
              type="button"
              className="btn btn-primary"
              onClick={ideaExcelDownloadSubmit}
            >
              Download (Total Ideas: {allIdeas.length})
            </button>
          </div>
        </div>

        {/* Status Summary */}
        <div className="col-12 col-md-5 col-lg-4">
          <div className="card shadow-sm">
            <div className="card-header py-2">
              <strong>Status Summary</strong>
            </div>
            <div className="card-body p-0">
              <table className="table table-sm table-bordered mb-0 align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "40%" }}></th>
                    <th className="text-center">Checked</th>
                
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: "green",
                          marginRight: 8,
                        }}
                      />
                      Approved
                    </td>
                   
                    <td className="text-center">{counts.approvedApproved}</td>
                  </tr>

        

                  <tr>
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: "orange",
                          marginRight: 8,
                        }}
                      />
                      Pending
                    </td>
                   
                    <td className="text-center">{counts.approvedPending}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Main Table */}
      <div className="table-responsive">
        <table className="table table-bordered table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>SW Id</th>
              
              <th>Idea Category</th>
              <th>Part No</th>
              <th>Savings</th>
              <th>Idea Effective</th>
              <th>Approved Status</th>
              <th>View More</th>
            </tr>
          </thead>
          <tbody>
            {paginatedIdeas.map((req) => {
            
              const qualityApprover = req.approvers.find((a) => a.role === "APPROVED");

              return (
                <tr key={req.id_x}>
                  <td>{req.idea_unique_id || `SWON-${req.id_x}`}</td>
                   
                  <td>{req.idea_category || req.idea_category_x || "-"}</td>
                   <td>{req.partno}</td>

                  <Tooltip title={req.benefit || ""} arrow>
                    <td>
                      {req.benefit?.slice(0, 15)}
                      {req.benefit?.length > 15 ? "..." : ""}
                    </td>
                  </Tooltip>

                  <td>{req.idea_effective}</td>

                  <td>
                    {qualityApprover ? (
                      <StatusDot
                        status={qualityApprover.status}
                        name="APPROVED"
                        onClick={() => handleDotClick(req, qualityApprover)}
                      />
                    ) : (
                      "-"
                    )}
                  </td>

                  {/* View more */}
                  <td style={{ cursor: "pointer" }} onClick={() => handleViewMore(req)}>
                    <FormatListBulletedIcon />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* View More Dialog */}
      <Dialog
        open={viewMoreOpenDialog}
        onClose={handleViewMoreCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Idea Details</DialogTitle>
        <DialogContent>
          {selectedIdea && (
            <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                  <strong>Employee Id:</strong> {selectedIdea.emp_id}
                </Typography>
                <Typography variant="body1">
                  <strong>Employee Email:</strong> {selectedIdea.emp_email}
                </Typography>
                <Typography variant="body1">
                  <strong>Sw.No:</strong> {selectedIdea.idea_unique_id || `SWON-${selectedIdea.id_x}`}
                </Typography>
                <Typography variant="body1">
                  <strong>Idea Category:</strong>{" "}
                  {selectedIdea.idea_category || selectedIdea.idea_category_x || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Part No:</strong> {selectedIdea.partno || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Description:</strong> {selectedIdea.part_description || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Proposed Idea:</strong>{" "}
                  {selectedIdea.proposed_idea || selectedIdea.proposed_idea_x || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Current Condition:</strong>{" "}
                  {selectedIdea.current_condition || "-"}
                </Typography>
               
              </Grid>

              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Savings:</strong> {selectedIdea.benefit || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Aggregate:</strong> {selectedIdea.idea_effective || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Model:</strong> {selectedIdea.model || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Variant:</strong> {selectedIdea.varient || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Sub Variant:</strong> {selectedIdea.subvarient || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Domain:</strong> {selectedIdea.domain || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Function:</strong> {selectedIdea.function || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Location:</strong> {selectedIdea.location || "-"}
                </Typography>

                <Typography variant="body1">
                  <strong>Document:</strong>{" "}
                  {selectedIdea.filepath ? (
                    <button
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        border: "transparent",
                        background: "transparent",
                        textDecoration: "underline",
                        padding: 0,
                      }}
                      onClick={() => downloadUploadedUserDocApi(selectedIdea)}
                    >
                      Download File
                    </button>
                  ) : (
                    "No File"
                  )}
                </Typography>

               
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewMoreCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Pagination */}
      <Stack alignItems="center" marginTop={2}>
        <Pagination
          count={totalPages || 1}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
          variant="outlined"
          shape="rounded"
        />
      </Stack>
    </div>
  );
};

export default IdeaTable;
